import React from 'react';

const TheDecayChamber = () => {
    return (
        <footer className="relative z-20 bg-black px-6 py-16 sm:py-20 md:py-24">
            <div className="max-w-4xl mx-auto text-center">
                <span className="home-kicker mb-4 block">Final Step</span>
                <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">A better first doorway.</h2>
                <p className="mx-auto mb-8 max-w-2xl text-base md:text-lg font-light leading-relaxed text-gray-400">
                    Early learners struggle with particle physics not because they cannot understand it, but because the subject is usually introduced at the wrong level of abstraction. Virtual Beamline lowers the entry barrier without removing the scientific core  -  turning a mathematically heavy subject into something you can see, test, question, and gradually understand.
                </p>
                <div className="mb-12 flex justify-center sm:mb-14 md:mb-16">
                     <a
                        href="https://simulator.virtualbeamline.org"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full max-w-xs rounded-full bg-white px-8 py-4 text-base font-bold text-black transition-transform hover:scale-105 sm:w-auto sm:max-w-none sm:text-lg"
                     >
                        Launch Simulator
                     </a>
                </div>
                
                
                <div className="mt-14 text-xs text-gray-700 sm:mt-16 md:mt-20">
                    &copy; 2026 Virtual Beamline.
                </div>
            </div>
        </footer>
    );
};

export default TheDecayChamber;
